import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import BenefitsSection from './components/BenefitsSection';
import OurLabelsSection from './components/OurLabelsSection';
import ContactSection from './components/ContactSection';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';
import NotFoundPage from './components/NotFoundPage';

const App: React.FC = () => {
    const [isNotFound, setIsNotFound] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;
    // If the path is exactly '/' or ends with '/index.html', it's the main application.
    // These are considered valid entry points for the SPA.
    // Any other path for which index.html is served (due to SPA fallback routing on the server)
    // should be treated as a 404 within the client-side application.
    if (!(path === '/' || path.endsWith('/index.html'))) {
      setIsNotFound(true);
    }
  }, []); // Run this check once when the component mounts

  useEffect(() => {
    const scrollToHash = () => {
      if (!window.location.hash) {
        return;
      }

      const targetId = window.location.hash.substring(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        return;
      }

      const headerElement = document.querySelector('header');
      const headerHeight = headerElement ? headerElement.getBoundingClientRect().height : 0;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerHeight;

      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    };

    // Let React paint the page before scrolling to the hash.
    const timeout = window.setTimeout(scrollToHash, 50);
    return () => window.clearTimeout(timeout);
  }, []);

  if (isNotFound) {
    return <NotFoundPage />;
  }
  
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 text-gray-700 font-sans">
      <Header />
      <main className="flex-grow">
        <Hero />
        <BenefitsSection />
        <OurLabelsSection />
        <PricingSection />
        <FAQSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default App;